import { removeCookie } from './cookieHandler';
import { useRouter } from 'next/navigation';

export const logout = () => {
  // Clear all authentication cookies
  removeCookie('token');
  removeCookie('userId');
  
  // Clear localStorage
  if (typeof window !== 'undefined') {
    localStorage.clear();
  }
  
  // Redirect to home page
  if (typeof window !== 'undefined') {
    window.location.href = '/';
  }
};

export const logoutWithRouter = (router: any) => {
  // Clear all authentication cookies
  removeCookie('token');
  removeCookie('userId');
  
  // Clear localStorage
  if (typeof window !== 'undefined') {
    localStorage.clear();
  }
  
  // Redirect to home page using router
  router.push('/');
};
